import { endpoints } from "@api/apis";
import AsyncStorage from "@react-native-async-storage/async-storage";
import axios from "axios";




export const kycAdditonalDetailsApi = async (payload: {
    applicationId: string;
    data: any;
}) => {
    let applicationId = payload.applicationId;
    let applicationIdStored = await AsyncStorage.getItem('application_id');

    if (applicationIdStored) {
        applicationId = applicationIdStored;
    }
    const response = await axios.post(endpoints.additionalDetails + applicationId, {
        ...payload.data
    });
    return response;
}


export const getAdditionalDetailsApi = async (payload: {
    applicationId: string;
}) => {
    let applicationId = payload.applicationId;
    let applicationIdStored = await AsyncStorage.getItem('application_id');

    if (applicationIdStored) {
        applicationId = applicationIdStored;
    }
    const response = await axios.get(endpoints.additionalDetails + applicationId);
    return response;
}

